import React from 'react';
import PropTypes from 'prop-types';
import { getGoalPageName } from '../FinancialPlanOPL/Goals/utils/getGoalPageName';

const GOAL_COLORS = {
  emergencyfund: '#f26f45',
  education: '#0447fa',
  debtmanagement: '#4d018f',
  homePurchase: '#1ba3ba',
  healthCare: '#f24545',
  retirement: '#f3ad45',
  largePurchase: '#a919ba',
  insurance: '#2419ba',
};

const GoalsSummary = ({ clientId, goalsList: fullGoalsList, hasLoaded }) => {
  const goalsList = fullGoalsList.filter(({ GoalType }) => GoalType !== 'estatePlanning');

  return (
    hasLoaded && (
      <div className="mobile-goals-summary">
        <div className="mobile-goals-summary-header">
          <img
            className="mobile-goals-summary-header-avatar"
            alt="please wait"
            src={`${window.ADV.settings.endpoints.imgDir}managed_accounts/Account.png`}
          />
          My Goals
        </div>
        <div className="mobile-content-scrollable-small-topnav-gray">
          <div className="mobile-consumer-heading-separator">Active Goals</div>
          <ul className="mobile-goals-summary-goals">
            {goalsList.map(goal => {
              const { GoalName, GoalId, icon, GoalType } = goal;
              return (
                <li key={GoalId} className="mobile-goals-summary-tile">
                  <button
                    className="mobile-goals-summary-button"
                    type="button"
                    onClick={() => {
                      ADV.util.Router.go2(getGoalPageName(GoalType), {
                        clientId,
                        goalId: GoalId,
                      });
                      window.scrollTo(0, 0);
                    }}
                  >
                    <div
                      className="mobile-goals-summary-color"
                      style={{ backgroundColor: GOAL_COLORS[GoalType] }}
                    >
                      <i className={`${icon} mobile-goals-summary-color-i`} />
                    </div>
                    <div className="mobile-goals-summary-link">
                      <div className="mobile-goals-summary-link-text">{GoalName}</div>
                      <div className="mobile-goals-summary-link-button" type="button">
                        <i className="fa fa-angle-right" />
                      </div>
                    </div>
                  </button>
                </li>
              );
            })}
          </ul>
          <button
            type="button"
            className="mobile-goals-summary-add"
            onClick={() => {
              window.ADV.util.Router.go2('ClientEditPlan', { clientId });
            }}
          >
            Add a Goal
          </button>
        </div>
      </div>
    )
  );
};

GoalsSummary.defaultProps = {
  goalsList: [],
};

GoalsSummary.propTypes = {
  clientId: PropTypes.string.isRequired,
  goalsList: PropTypes.arrayOf({}),
  hasLoaded: PropTypes.bool.isRequired,
};

export default GoalsSummary;
